module.exports = __webpack_public_path__ + "static/img/aboutUs04.42af27c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/aboutUs04.jpg
// module id = 1356
// module chunks = 1